module.exports = "/packs/images/the_mix_logo~d4988a9c35eee5af4c4b83e07e29f342.png";